module.exports = __webpack_public_path__ + "static/on-the-road-1f29d1fabae2425c34bc15e9dfc2d12a.jpg";